import { createReducer, on } from '@ngrx/store';
import { DevicesApiActions, DeviceApiActions } from './devices-os-update-status.actions';
import { adapter, initialState } from './devices-os-update-status.state';

export const DevicesOsUpdateStatesFeatureKey = 'getDevicesOsUpdateStatuses';

export const DevicesOsUpdateStatesReducer = createReducer(
  initialState,
  on(DevicesApiActions.osUpdateStatesLoaded, (state, { osUpdateStatuses }) =>
    adapter.upsertMany(osUpdateStatuses, state)
  ),
  on(DeviceApiActions.osUpdateStateLoaded, (state, { osUpdateStatus }) => {
    const id = adapter.selectId(osUpdateStatus) as string;
    const update = {
      id: id,
      changes: osUpdateStatus,
    };

    return adapter.updateOne(update, state);
  })
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectDevicesOsUpdateStatusesIds = selectIds;

export const selectDevicesOsUpdateStatusesEntities = selectEntities;

export const selectDevicesOsUpdateStatuses = selectAll;
